import { useParams } from "react-router";
import useTaskLayout from "../../components/loyauts/use-task-layout";
import Task from "../../components/task";
import useTask from "../../modules/tasks/hooks/use-task";

type Props = {}

const TaskPage: React.FC<Props> = () => {

    const {id} = useParams<{id: string}>();

    const {task, isLoading} = useTask(id);

    useTaskLayout(id);

    return <div className="task-page">
        {isLoading && <p>Ładuję....</p>}
        {task && <Task task={task} />}
    </div>
}

export default TaskPage;
